import {GameWinPresentationInitialState} from 'src/winpresentation/states/GameWinPresentationInitialState';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';

export class GameWinPresentationInitialWinNoMultiplierState extends GameWinPresentationInitialState {

	protected startInitialWinPresentation(): void {
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		!WinUtils.isBigWin(logic) && this.emit(GameWinPresentationEvents.COUNTING_STARTED, logic.currentSpinWin);
		this.view.playWinNumberCounter(logic.currentSpinWin,
			false, // no countup here
			2,
			false);

		this.emit(WinPresentationEvents.INITIAL_ANIMATION_STARTED);
	}
}



// WEBPACK FOOTER //
// ./src/winpresentation/states/GameWinPresentationInitialWinNoMultiplierState.ts